import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { Sync, EditRounded } from '@mui/icons-material';
import ReplaceItem from './ReplaceItem';
import { useAcceptRecommendationWithChangesMutation, useCreateCustomRecommendationMutation } from '../../../api/itemRecommendationSlice';
import { useLogUserActionMutation } from '../../../api/physicianDashboardSlice';
import { useTheme } from '@mui/system';

function EditItemPanel({ physicianItem, recommendation, draft, setIsEditing, closeItemDetails, variant }) {
    const theme = useTheme();
    const [acceptRecommendationWithChanges] = useAcceptRecommendationWithChangesMutation();
    const [createCustomSwap] = useCreateCustomRecommendationMutation();
    const [logUserAction] = useLogUserActionMutation();

    function handleEdit() {
        setIsEditing(true);
    }

    const logCustomSwap = async(newItem) => {
        await logUserAction({
            action: 'made_custom_swap',
            data: {
                location: 'EditItemPanel',
                item: physicianItem,
                recommendation: recommendation,
                newItem: newItem
            }
        });
    }

    const acceptCustomSwap = async(newItem) => {
        const customValue = Math.round((physicianItem.open_quantity + (physicianItem.hold_quantity * 0.3)) * physicianItem.cost * (draft.card.yearly_stats?.usage_count ?? 1)) - Math.round((physicianItem.open_quantity + (physicianItem.hold_quantity * 0.3)) * newItem.cost * (draft.card.yearly_stats?.usage_count ?? 1));

        if (recommendation) {
            await acceptRecommendationWithChanges({
                draft: draft,
                recommendation: recommendation,
                status: 'custom_swap',
                customValue: customValue,
                newItem: newItem,
                customOpen: physicianItem.open_quantity,
                customHold: physicianItem.hold_quantity,
            });
        } else {
            await createCustomSwap({
                draft: draft,
                item: physicianItem,
                status: 'custom_swap',
                customValue: customValue,
                newItem: newItem,
                customOpen: physicianItem.open_quantity,
                customHold: physicianItem.hold_quantity,
            });
        }

        logCustomSwap(newItem);

        closeItemDetails();
    }

    const [isShowingReplace, setIsShowingReplace] = React.useState(false);
    const curItem = physicianItem ?? recommendation.item;
    let openQuantity = curItem.open_quantity;
    let holdQuantity = curItem.hold_quantity;

    if (recommendation?.status === 'custom_addition' || recommendation?.status === 'custom_update' || recommendation?.status === 'custom_swap' ) {
        openQuantity = recommendation.custom_open;
        holdQuantity = recommendation.custom_hold;
    } else if (recommendation?.status === 'accepted') {
        openQuantity = recommendation.open_quantity;
        holdQuantity = recommendation.hold_quantity;
    }

    const itemRemoved = (recommendation?.type === 'removal' && recommendation.status === 'accepted') || recommendation?.status === 'custom_removal';
    const isSwap = recommendation?.type === 'swap' || recommendation?.type === 'compliance';

    // if there is no recommendation or the current rec is open, then we can edit
    const allowEdit = !recommendation || recommendation.status === 'open' && !isSwap;

    return (
        <Stack p={2} spacing={2} direction='column' backgroundColor={theme.palette.background.white} borderRadius={1}>
            { variant === 'peer_comparison' ?
                <Typography variant='bold' >My Card</Typography> : 
                null 
            }
            <Stack direction='row' alignItems='center' justifyContent='space-between'>
                { itemRemoved ? 
                    <Typography variant='heavy' sx={{ fontSize: '14px' }}>Item Removed</Typography> :
                    <Stack spacing={1}>
                        <Typography variant='heavy' sx={{ fontSize: '14px' }}><strong>Open Quantity:</strong> {openQuantity}</Typography>
                        <Typography variant='heavy' sx={{ fontSize: '14px' }}><strong>Hold Quantity:</strong> {holdQuantity}</Typography>
                    </Stack>
                }
                { allowEdit && (
                    <Stack direction='row' spacing={1}>
                        <Button variant='outlined' color='primary' onClick={() => setIsShowingReplace(true)} startIcon={<Sync />}>Replace</Button>
                        { (!recommendation || recommendation.type !== 'addition') && !curItem.is_removed && recommendation?.status !== 'accepted' && 
                            <Button variant='outlined' color='primary' onClick={handleEdit} startIcon={<EditRounded />}>Edit</Button>
                        }
                    </Stack>
                )}
                <ReplaceItem item={curItem} draft={draft} open={isShowingReplace} setOpen={setIsShowingReplace} swapItem={acceptCustomSwap} />
            </Stack>
        </Stack>
    )
}

export default EditItemPanel;
